import openModal from './openModal';
import resetForm from './resetForm';

export default () => (dispatch) => {
    dispatch(resetForm());
    dispatch(openModal(false));
};
